/**
 * PrestadorCardSkeleton: placeholder pulsante que se muestra mientras se
 * cargan los prestadores de la Guía TS+. Emula el layout del PrestadorCardBonda
 * para evitar salto de contenido (CLS).
 */
import React from 'react';

export default function PrestadorCardSkeleton({ testId }) {
  return (
    <div
      className="w-full bg-white rounded-2xl border border-gray-200 overflow-hidden animate-pulse"
      data-testid={testId || 'prestador-card-skeleton'}
    >
      <div className="relative aspect-[4/3] bg-gradient-to-br from-purple-100 via-purple-50 to-white" />
      <div className="pt-10 pb-4 px-3 text-center space-y-2">
        <div className="h-3.5 bg-gray-200 rounded w-3/4 mx-auto" />
        <div className="h-3 bg-gray-100 rounded w-full mx-auto" />
        <div className="h-3 bg-gray-100 rounded w-2/3 mx-auto" />
      </div>
    </div>
  );
}
